import { useContext } from 'react';

import WorkOrderPreviewContext from '@atom/components/workOrderPreview/WorkOrderPreviewContext';

import PreviewHeaderInfo from './PreviewHeaderInfo';
import PreviewHeaderTools from './PreviewHeaderTools';

import classes from './workOrderPreviewHeader.module.css';

const WorkOrderPreviewHeader = () => {
  const { workOrderDetail } = useContext(WorkOrderPreviewContext);

  return (
    <div className={classes.headerContainer}>
      <div className={classes.topHeaderRow}>
        <div className={classes.workOrderName}>{workOrderDetail.name}</div>
        <PreviewHeaderTools />
      </div>
      <PreviewHeaderInfo />
    </div>
  );
};

export default WorkOrderPreviewHeader;
